import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56c3f022"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "user-picture-edition" }
const _hoisted_2 = { class: "user-picture-form" }
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "picture-help" }
const _hoisted_5 = { class: "info-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-info-circle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_7 = { class: "picture-buttons" }
const _hoisted_8 = ["disabled"]

import { ComputedRef, Ref, computed, ref, toRefs } from 'vue'

  import UserPicture from '@/components/User/UserPicture.vue'
  import { AUTH_USER_STORE, ROOT_STORE } from '@/store/constants'
  import { TAppConfig } from '@/types/application'
  import { IUserProfile } from '@/types/user'
  import { useStore } from '@/use/useStore'
  import { getReadableFileSize } from '@/utils/files'

  interface Props {
    user: IUserProfile
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    user: null
  },
  setup(__props: any) {

const props = __props as {
    user: IUserProfile
  }

  

  const store = useStore()

  const { user } = toRefs(props)
  const errorMessages: ComputedRef<string | string[] | null> = computed(
    () => store.getters[ROOT_STORE.GETTERS.ERROR_MESSAGES]
  )
  const appConfig: ComputedRef<TAppConfig> = computed(
    () => store.getters[ROOT_STORE.GETTERS.APP_CONFIG]
  )
  const fileSizeLimit = appConfig.value.max_single_file_size
    ? getReadableFileSize(appConfig.value.max_single_file_size)
    : ''
  let pictureFile: Ref<File | null> = ref(null)

  function deleteUserPicture() {
    store.dispatch(AUTH_USER_STORE.ACTIONS.DELETE_PICTURE)
  }
  function updatePictureFile(event: Event & { target: HTMLInputElement }) {
    if (event.target.files) {
      pictureFile.value = event.target.files[0]
    }
  }
  function updateUserPicture() {
    if (pictureFile.value) {
      store.dispatch(AUTH_USER_STORE.ACTIONS.UPDATE_USER_PICTURE, {
        picture: pictureFile.value,
      })
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(errorMessages))
        ? (_openBlock(), _createBlock(_component_ErrorMessage, {
            key: 0,
            message: _unref(errorMessages)
          }, null, 8, ["message"]))
        : _createCommentVNode("", true),
      _createVNode(UserPicture, { user: _unref(user) }, null, 8, ["user"]),
      _createElementVNode("form", {
        onSubmit: _withModifiers(updateUserPicture, ["prevent"])
      }, [
        _createElementVNode("input", {
          type: "file",
          name: "picture",
          accept: ".png,.jpg,.gif",
          onInput: updatePictureFile
        }, null, 32),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('workouts.MAX_SIZE')) + ": " + _toDisplayString(_unref(fileSizeLimit)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "submit",
            disabled: !_unref(pictureFile)
          }, _toDisplayString(_ctx.$t('user.PROFILE.PICTURE_UPDATE')), 9, _hoisted_8),
          (_unref(user).picture)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "danger",
                onClick: deleteUserPicture
              }, _toDisplayString(_ctx.$t('user.PROFILE.PICTURE_REMOVE')), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "cancel",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/profile')))
          }, _toDisplayString(_ctx.$t('user.PROFILE.BACK_TO_PROFILE')), 1)
        ])
      ], 40, _hoisted_3)
    ])
  ]))
}
}

})